module.exports = __webpack_public_path__ + "img/MX.d827b358.webp";